export default __webpack_public_path__ + "static/media/PL.98a4f292.svg";